import LegalLayout, { P, H2, UL } from "./LegalLayout";

export default function Refunds() {
  return (
    <LegalLayout title="Cancellation &amp; Refund Policy" updated="February 2026">
      <P>We keep this policy simple and honest. If Vendorly did not work for you, tell us within 7 days of your payment and we will process a refund.</P>

      <H2>1. Cancellation</H2>
      <UL>
        <li>Vendorly has <strong>no auto-renewal</strong>. Your subscription lapses naturally at the end of the paid period unless you manually renew.</li>
        <li>You can stop using Vendorly any time — simply do not renew.</li>
        <li>To permanently delete your account and all associated data (customer list, messages, receipts), email us and we will action it within 30 days.</li>
      </UL>

      <H2>2. Refund eligibility</H2>
      <P>You are eligible for a full refund if <strong>all</strong> of the following are true:</P>
      <UL>
        <li>You request the refund within <strong>7 calendar days</strong> of the payment.</li>
        <li>You have sent fewer than <strong>50 WhatsApp messages</strong> using the paid credit.</li>
        <li>Your account was not suspended for policy violations.</li>
      </UL>

      <H2>3. When refunds are NOT available</H2>
      <UL>
        <li>More than 7 days have passed since the payment.</li>
        <li>You have sent 50 or more WhatsApp messages under the paid subscription.</li>
        <li>Your account was suspended for spam, fraud, or violations of Meta's WhatsApp Business Policy.</li>
        <li>The subscription is more than 90 days old.</li>
      </UL>

      <H2>4. How to request a refund</H2>
      <P>Email <a href="mailto:vendorlyadmin@gmail.com" className="text-brand-primary font-semibold">vendorlyadmin@gmail.com</a> from the email address linked to your Vendorly account with:</P>
      <UL>
        <li>Subject: <em>"Refund request — [your business name]"</em></li>
        <li>The Razorpay Payment ID (starts with <code>pay_...</code>) from your billing receipt</li>
        <li>A brief reason so we can improve</li>
      </UL>

      <H2>5. Refund processing timeline</H2>
      <UL>
        <li>We review and approve refunds within <strong>2 business days</strong>.</li>
        <li>Once approved, Razorpay initiates the refund within 24 hours.</li>
        <li>The amount reflects in your original payment method within <strong>5–7 business days</strong> depending on your bank.</li>
      </UL>

      <H2>6. Chargebacks</H2>
      <P>Please contact us before initiating a chargeback with your bank — 99% of issues are resolved amicably via email in under 48 hours. Chargebacks initiated without contacting us first may result in permanent account suspension.</P>

      <H2>7. Partial refunds</H2>
      <P>For subscriptions with unused days, we may offer a pro-rata refund at our discretion — for example, if a promised feature was unavailable for more than half your billing period.</P>

      <H2>8. Data after cancellation</H2>
      <P>Once you cancel and request full account deletion, your customer list, messages, and personal data are permanently deleted within 30 days. Payment records are retained for 7 years to meet Indian tax and audit obligations, as required by law.</P>

      <H2>9. Contact</H2>
      <P>Refund questions or complications? Reach us at <a href="mailto:vendorlyadmin@gmail.com" className="text-brand-primary font-semibold">vendorlyadmin@gmail.com</a>. We respond within 24 hours on business days.</P>
    </LegalLayout>
  );
}
